<div mat-dialog-title class="dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  <h3 l10nTranslate>shared.privateAssetSetting</h3>
</div>
<div class="privacysettings-container">
  <div mat-dialog-content>
    <p l10nTranslate *ngIf="isUserAllowed">shared.togglePrivate</p>
    <form [formGroup]="privacySettingsFormGroup">
      <div class="privacy-toggle" *ngIf="isUserAllowed">
        <mat-button-toggle-group
          name="privacyChange"
          aria-label="Change Privacy"
          formControlName="privacyStatus"
          hideSingleSelectionIndicator
        >
          <mat-button-toggle class="toggle-button" value="off">
            <mat-icon>lock_open</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle class="toggle-button" value="on">
            <mat-icon>lock</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div *ngIf="privacyStatus === 'on'">
        <div class="flex-grid" *ngIf="isUserAllowed; else showReasonAndDate">
          <div class="expiry-date">
            <div class="privacyfields-label">
              <label l10nTranslate>shared.expiryDate</label>
            </div>
            <mat-form-field appearance="outline" class="expirydate-input">
              <input
                matInput
                autocomplete="no-autofill"
                [min]="minExpiryDate"
                [matDatepicker]="picker"
                [placeholder]="'shared.select' | xTranslate"
                formControlName="expiryDate"
                (dateChange)="onDateChange($event)"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="privacySettingsFormGroup.get('expiryDate').hasError('matDatepickerMin')" l10nTranslate>
                shared.expiryDateNoPastDate
              </mat-error>
            </mat-form-field>
          </div>
          <div class="expiry-reason">
            <div class="privacyfields-label">
              {{ 'shared.reasonPrivate' | xTranslate }} <span class="required-icon"> &#x2a; </span>
            </div>
            <mat-form-field appearance="outline">
              <mat-select
                hideSingleSelectionIndicator="true"
                [placeholder]="'shared.select' | xTranslate"
                formControlName="privacyReason"
              >
                <mat-option [value]="null">--</mat-option>
                <mat-option *ngFor="let val of privacyReasons$ | async" [value]="val.key">
                  {{ val.value }}
                </mat-option>
              </mat-select></mat-form-field
            >
          </div>
        </div>
        <ng-template #showReasonAndDate>
          <div class="reason-and-dates">
            <div class="privacy-reason-info">
              <label
                >{{ 'shared.assetLockedOn' | xTranslate }} <span>{{ privacyStartDate }}</span>
              </label>
              <label
                >{{ 'shared.reason' | xTranslate }} <span>{{ privacyReason }}</span></label
              >
            </div>
            <div class="privacy-reason-info">
              <label
                >{{ 'recordsSearch.startDate' | xTranslate }} <span>{{ privacyStartDate }}</span></label
              >
              <label
                >{{ 'shared.expiryDate' | xTranslate }} <span>{{ privacyEndDateDisplay }}</span></label
              >
            </div>
          </div>
          <p class="users-heading" l10nTranslate>shared.usersOrTeams</p>
        </ng-template>
        <div class="card-container">
          <div class="searchuser" *ngIf="isUserAllowed">
            <div class="search__label" l10nTranslate>shared.addUsersTeams</div>
            <p l10nTranslate>shared.usersHavingAccess</p>
            <div class="search-box">
              <div class="searchContainer">
                <input type="text" autocomplete="no-autofill" class="searchBox" formControlName="searchFormControl" />
                <em class="fa fa-search searchIcon"></em>
              </div>
            </div>
          </div>
          <ng-container *ngIf="loading; else usersList">
            <div class="nousers-label" l10nTranslate>shared.searchingUsersTeams</div>
          </ng-container>
          <ng-template #usersList>
            <div class="user-list">
              <ng-container *ngFor="let element of userTeamList">
                <ng-container *ngIf="element.isUser; else teamCard">
                  <miq-privacy-contact-card
                    [selectedContactComponent]="false"
                    [selectedUsersTeams]="selectedUsersTeams"
                    [user]="element"
                    [selected]="element.selected"
                    [isOnMIQ]="element.source_system === 'MIQ'"
                    (change)="onUserSelected($event)"
                  ></miq-privacy-contact-card
                ></ng-container>
                <ng-template #teamCard>
                  <miq-privacy-team-contact-card
                    [selectedContactComponent]="false"
                    [selectedUsersTeams]="selectedUsersTeams"
                    [team]="element"
                    [selected]="element.selected"
                    [isOnMIQ]="element.source_system === 'MIQ'"
                    (change)="onTeamSelected($event)"
                  ></miq-privacy-team-contact-card> </ng-template
              ></ng-container>
            </div>
            <div class="user-list-selected" *ngIf="existingTeams.length || existingUsers.length">
              <ng-container *ngFor="let element of existingUsers">
                <miq-privacy-contact-card
                  *ngIf="element.selected"
                  [isUserAllowed]="isUserAllowed"
                  [selectedContactComponent]="true"
                  [user]="element"
                  [selected]="element.selected"
                  [isOnMIQ]="element.source_system === 'MIQ'"
                  (change)="onUserSelected($event)"
                ></miq-privacy-contact-card>
              </ng-container>
              <ng-container *ngFor="let element of existingTeams">
                <miq-privacy-team-contact-card
                  *ngIf="element.selected"
                  [isUserAllowed]="isUserAllowed"
                  [selectedContactComponent]="true"
                  [team]="element"
                  [selected]="element.selected"
                  [isOnMIQ]="element.source_system === 'MIQ'"
                  (change)="onTeamSelected($event)"
                ></miq-privacy-team-contact-card>
              </ng-container>
            </div>
          </ng-template>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions *ngIf="isUserAllowed">
    <p *ngIf="isRecordPrivate">{{ 'shared.assetLockedOn' | xTranslate }} {{ privacyStartDate }}</p>
    <button
      mat-flat-button
      color="primary"
      [disabled]="(privacySettingsFormGroup.invalid && privacyStatus === 'on') || !isUserAllowed"
      (click)="savePrivacySettings()"
    >
      {{ 'recordsSearch.save' | xTranslate | uppercase }}
    </button>
  </div>
</div>
